import React from "react";
import { t, get } from "../../content";
import { useLocale } from "../../locale";
import PageLayout from "../../components/layoutComponents/PageLayout";

function Faq() {
  const { locale } = useLocale();
  const items = get("help.items") || [];

  return (
    <div className="bg-cover" key={locale}>
      <PageLayout>
        <div className="section-wrapper">
          <h1>{t("help.heading")}</h1>
        </div>
      </PageLayout>
      <PageLayout>
        <div className="section-wrapper">
          {items.map((item, index) => {
            return (
              <div key={item.id || index} className="mar-25 bottom">
                <p className="bold m-10 bottom">{item.title}</p>
                <p>{item.description}</p>
              </div>
            );
          })}
        </div>
      </PageLayout>
    </div>
  );
}

export default Faq;
